<template>
    <GeneralInventory />
</template>

<script>
import GeneralInventory from "../../components/InventoryControl/GeneralInventory.vue";
export default {
  components: {
    GeneralInventory,
  },
};
</script>